import {Component, Input, OnDestroy} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {MenuService} from 'mclane-apptemplate-lib';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnDestroy {
    @Input() menuItemList: Observable<any[]>;
    @Input() customerId: number;
    @Input() confirmationCount: Observable<number>;
    sub: Subscription;


    constructor(public router: Router, public keycloakService: KeycloakService, public menuService: MenuService
    ) {
        this.sub = this.menuService.eventRan.subscribe((result) => {
            this.ClickedItem(result);
        });
        this.buildMenu();
    }
    buildMenu() {

    }

    ClickedItem($event) {
        console.log($event);
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
